import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Col, Row, Button } from 'react-bootstrap';

import { updateCertificationStatusById } from 'api/certifications/certifications';

import { certificationActions } from 'store/slices/certification/certificationSilce';

import styles from 'assets/scss/wizard/emetBreak.module.scss';
import { handleApiError } from 'utils';


const EmetWelcome = ({certification}) => {
    const token = useSelector(state => state.authentication.user?.token);
    const dispatch = useDispatch();

    const handleStartExam = () => {
        updateCertificationProgress();
        dispatch(certificationActions.incrementStep()); // Avanza al siguiente paso (primera sección del examen)
    };

    const updateCertificationProgress = async () => {
		try {
			await updateCertificationStatusById(certification.id, { status: 1 }, token);
		} catch (error) {
			handleApiError(error);
		}
	};

    return (
        <>
            <Row className="align-items-center justify-content-center mt-5">
                <Col lg={12} className="text-center">
                    <h2 className={`${styles.welcomeMessage} mb-4`}>
                        ¡Bienvenido al Examen de Certificación EMET!
                    </h2>
					<p className={`${styles.instructions} mb-5`}>
						Haz clic en el botón a continuación para comenzar el examen. Te recomendamos que te prepares antes de iniciar.
                    </p>
					<Button 
                        variant="primary" 
                        size="lg" 
                        onClick={handleStartExam} // Llama a la función cuando se hace clic
                        className={`${styles.startButton}`} >
                        Comenzar
                    </Button>
                </Col>
            </Row>
        </>
    );
};

export default EmetWelcome;